import { defineQuery } from "@rocicorp/zero";
import { z } from "zod";
import type {} from "../zero-context";
import { zql } from "../schema";

/**
 * Phase 2 community curation reads. Member-gated: a caller only sees signals
 * for a channel they're an active member of (channel → members exists check,
 * filtering tombstoned memberships per queries.md). Consumers aggregate
 * per-message counts client-side.
 */
export const communitySignalsQueries = {
  byChannel: defineQuery(z.string(), ({ args: channelId, ctx: { sub } }) =>
    zql.community_signals
      .where("channel_id", channelId)
      .whereExists("channel", (cq) =>
        cq.whereExists("members", (mq) =>
          mq.where("user_id", sub).where("removed_at", "IS", null),
        ),
      ),
  ),
};
